import {css} from 'emotion'
import { Colors } from '../'
import { Link } from '../typo'

export const CounterfeitsCardStyle = css({
  alignItems: 'center',
  padding: '1rem 2rem',
  background: 'white',
  boxShadow: ` 0 0 20px 0 ${Colors.shadow}`,
  margin: '2rem 0',
  '.counterfeit': {   
    '&-title': {
      color: Colors.red,
      textTransform: 'uppercase',
      fontWeight: 'bold',
      maxWidth: '100%',
      flexBasis: '100%',
      margin: '1rem 0',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(100% - 240px)',
        flexBasis: 'calc(100% - 240px)',
        margin: 0,
      },
      'svg': {
        fill: Colors.red,
        marginRight: '1rem',
        verticalAlign: 'middle',
      }
    },
    '&-subtitle': {

    },
    '&-bookmark': {
      width: 60,
      '@media (min-width: 1024px)': {
        width: 80,
      },
      'button': {
        background: 'white',
      }
    },
    '&-link': {
      ...Link,
      color: Colors.grey,
      width: 160,
      transition: 'color 200ms ease',
      '&:hover': {
        color: 'black',
      }
    },
  }
})

export const CounterfeitsContainer = css({
 '.counterfeits-container': {
   margin: '4rem 0'
 }
})


export const CounterfeitContentStyle = (picture) => css({
  maxWidth: '100%',
  flexBasis: '100%',
  '@media (min-width: 1024px)': {
    maxWidth: '50%',
    flexBasis: '50%',
  },
  '.bloc-picture': {
    '&__picture': {
      width: '100%',
      height: 400,
      background: `url(${picture}) no-repeat center`,
      backgroundSize: 'contain'
    },
    '&__legend': {
      textTransform: 'uppercase',
      fontSize: '0.75em',
      padding: '1rem 0',
    }
  },
  'ol': {
    listStyle: 'none',
    padding: 0,
    'li': {
      counterIncrement: 'step-counter',
      paddingLeft: '2rem',
      position: 'relative',
      '&:before': {
        content: 'counter(step-counter)',
        fontSize: '1rem',
        fontWeight: 'bold',
        position: 'absolute',
        top: '0.5rem',
        left: 0,
        
      },
      '&:nth-child(-n + 9)': {
        '&:before': {
          content: '"0" counter(step-counter)',
        }
      }
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/containers/counterfeits.js